import React, { useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

import AppInfo from "./appInfo";
import useTheme from "../hooks/useTheme";
import { ERPType, DeviceType, SupportedType } from "../types/types";
import Platform from "./platform/Platform";
import ERP from "./erp/ERP";
import useWindowDimensions from "../hooks/useWindowDimensions";
import SupportedDevices from "./supportedDevices";
import Store from "./store/Store";
import Authentication from "./Authentication";

export default function ListItem(props: {
  name: string;
  note: string;
  logo: string;
  fallbackLogo: string;
  platforms: SupportedType[];
  devices: DeviceType[];
  erp: ERPType[];
  authentication: string[];
}) {
  const theme = useTheme();
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();

  const styles: {
    container: React.CSSProperties;
    items: React.CSSProperties;
    note: React.CSSProperties;
  } = {
    container: {
      backgroundColor: theme.background,
      paddingTop: 15,
      paddingBottom: 15,
    },
    items: {
      justifyContent: "center",
    },
    note: {
      textAlign: "center",
      width: isSmallLayout || isMediumLayout ? "100%" : "80%",
    },
  };

  const [showDevices, setShowDevices] = useState<boolean>(false);

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: isSmallLayout || isMediumLayout ? "100%" : "80%",
          }}
        >
          <Grid2
            container
            alignItems="center"
            flexDirection={isSmallLayout || isMediumLayout ? "column" : "row"}
          >
            <Grid2 xs>
              <AppInfo
                logo={props.logo}
                fallbackLogo={props.fallbackLogo}
                name={props.name}
                hasDevices={props.devices !== undefined}
                onIconClick={() => setShowDevices(!showDevices)}
              />
            </Grid2>

            <Grid2 xs>
              <Platform platforms={props.platforms} style={styles.items} />
            </Grid2>
            <Grid2 xs>
              <Store platforms={props.platforms} style={styles.items} />
            </Grid2>
            <Grid2 xs>
              <Authentication
                authentication={props.authentication}
                style={styles.items}
              />
            </Grid2>
            <Grid2 xs>
              <ERP erp={props.erp} style={styles.items} />
            </Grid2>
          </Grid2>
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={styles.note}>{props.note}</div>
        </div>

        {showDevices && <SupportedDevices devices={props.devices} />}
      </div>
    </div>
  );
}
